import MainSider from './MainSider'

MainSiderWrapper = (Component) ->
  <MainSider>
    <Component />
  </MainSider>

export default MainSiderWrapper
